import actionTypes from '../actions/actionTypes';

export default function (state = 'uk', action = {}) {
    if (action.type === actionTypes.LANG) {
        return action.value;
    } else {
        return state;
    }
}
